module.exports = __webpack_public_path__ + "static/media/50.3edbb71a.jpg";